import { BRAND_PRIMARY } from '../../theme/brand';

/**
 * Collapsed-sidebar mark: white "A" on the Atteniv brand teal disc.
 *
 * Mirrors the favicon defined in the marketing site's `src/app/icon.tsx`
 * (circular, `#16423C` background, white glyph) so the portal and the public
 * site present the same mark.
 */
export const LogoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    role="img"
    aria-label="Atteniv"
    style={{ height: 28, width: 28, display: 'block' }}
  >
    <circle cx="16" cy="16" r="16" fill={BRAND_PRIMARY} />
    <text
      x="16"
      y="17"
      textAnchor="middle"
      dominantBaseline="central"
      fill="#ffffff"
      fontFamily="Inter, -apple-system, BlinkMacSystemFont, sans-serif"
      fontSize="18"
      fontWeight="600"
    >
      A
    </text>
  </svg>
);
